export default __webpack_public_path__ + "0dd298d55c44113a1841fa7c4ff1567f.png";